import React from "react";
import parse from 'html-react-parser';

const NewsCard = ({ news, index, onDelete = () => {}, onEdit = () => {}}) => {
  return (
    <div className="flex bg-white shadow rounded overflow-hidden">
      <img
        src={news.image}
        // alt={news.title}
        alt={`Preview ${index + 1}`}
        className="w-1/3 object-cover"
      />
      <div className="w-2/3 p-4">
        <h2 className="text-lg font-bold mb-2">{news.title}</h2>
        <p className="text-gray-600 text-sm mb-4">{parse(news.description)}</p>
        <div className="flex justify-end gap-5">
          <button className="px-4 py-2 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] hover:bg-gray-300 rounded" onClick={() => onDelete(news.id)}>Delete</button>
          <button className="px-4 py-2 bg-[#92288C] text-white hover:bg-[#92288C] rounded" onClick={() => onEdit(news)}>Edit</button>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;
